export const COURSE_CODES = {
  LN_TEORIA: 4117,
  LN_PRACTICA_FIN_SEMANA: 4118,
  LN_PRACTICA_ENTRE_SEMANA: 4119,
  LN_PRACTICA_TEORIA_FIN_SEMANA_PACK: 4697,
  LN_PRACTICA_TEORIA_ENTRE_SEMANA_PACK: 4695,
  MEDIC_CERTIFICATE: 4213,
  EXPRESS_DELIVERY: 4189,
  ORDINARY_MAIL_DELIVERY: 6956,
};
